// Admin print history — dedicated page wrapping the operator-facing
// HistoryPanel (it already speaks the print-job API).  Sits in the
// admin side-nav so admins don't have to switch to the operator
// /print page and click a tab to see the same table.

import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components/PageHeader";
import { RequirePermission } from "@/components/RequirePermission";
import { HistoryPanel } from "@/pages/Print";

export default function PrintHistory() {
  const { t } = useTranslation();
  return (
    <RequirePermission codes="print.use">
      <PageHeader
        eyebrow={t("printHistory.eyebrow")}
        title={t("printHistory.title")}
        description={t("printHistory.description")}
      />
      <div className="mt-4">
        <HistoryPanel />
      </div>
    </RequirePermission>
  );
}
